export const TOKEN_KEY = 'algotrade_token';
export const USER_KEY  = 'algotrade_user';

// Icon + accent color for each role key received from /me
// Add more entries here if your backend adds new roles
export const ROLE_STYLE_MAP = {
  trader:     { icon: '📈', color: 'rgba(0,229,160,0.1)'  },
  admin:      { icon: '🛡',  color: 'rgba(61,142,240,0.1)' },
  viewer:     { icon: '👁',  color: 'rgba(245,166,35,0.1)' },
  analyst:    { icon: '📊', color: 'rgba(245,166,35,0.1)' },
  manager:    { icon: '🗂',  color: 'rgba(61,142,240,0.1)' },
  superadmin: { icon: '⚡', color: 'rgba(255,77,109,0.1)' },
};

export const STATUS_META = {
  open:      { label: 'OPEN'      },
  closed:    { label: 'CLOSED'    },
  partial:   { label: 'PARTIAL'   },
  cancelled: { label: 'CANCELLED' },
};

export const SIGNAL_COLORS = {
  BUY:  '#00e5a0',
  SELL: '#ff4d6d',
};

export const STATUS_COLORS = {
  open:      '#00e5a0',
  closed:    '#5a6a82',
  partial:   '#f5a623',
  cancelled: '#ff4d6d',
};